<div class="editorial-astrea">

    <mat-drawer-container class="astrea-container">

        <section class="astrea-header">
            <mat-toolbar>
                <astrea-menu-navbar
                    (handleMenu)="handleMenu()"
                ></astrea-menu-navbar>
            </mat-toolbar>
        </section>

        <section class="astrea-content">
            <router-outlet></router-outlet>
        </section>

        <section>
            <astrea-footer></astrea-footer>
        </section>


        <!-- Menu Mobile -->
        <mat-drawer #sidenav [mode]="'over'">
            <astrea-menu-leftnav
                (handleMenu)="handleMenu()"
            ></astrea-menu-leftnav>
        </mat-drawer>


    </mat-drawer-container>

    <div class="whatsapp">
        <a href="https://wa.me/5491126827008?text=Quiero%20informaci%C3%B3n%20sobre%20Astrea%20Virtual" target="_blank" title="Contactate por WhatsApp">
            <img src="/assets/images/whatsapp-logo.png" alt="Logo WhatsApp" />
        </a>
    </div>

    <div *ngIf="devMode != 'production'" class="development-mode">
        <p>Development</p>
    </div>

</div>
